export const handleResponse = async (reqFn: Function, url?: string) => {
  try {
    const response = await reqFn();
    if (response.error) throw response.error;
    return response?.data;
  } catch (error: any) {
    return error?.response?.data || error;
  }
};
